import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { handleSuccessToast } from 'src/components/molecules';
import { TopBanner } from 'src/components/molecules/TopBanner';
import { ChangePasswordNew } from 'src/components/organisms/ChangePasswordNew/ChangePasswordNew';
import { AccountType, FormState } from 'src/types';
import LoginContainer from '../LoginContainer';

interface Props {
  token: string;
  kind?: AccountType.App | AccountType.Portal;
  isEnforceBanner?: boolean;
}

export const ResetPassword = ({ isEnforceBanner = false, ...props }: Props) => {
  const [redirect, setRedirect] = React.useState(false);
  const [bannerOpen, setBannerOpen] = React.useState(isEnforceBanner);

  const onPasswordChangeSuccess = () => {
    if (props.kind !== AccountType.App) {
      handleSuccessToast({
        toastMessage: 'Password updated',
        toastDescription:
          'Your password has been successfully updated. Thanks for taking this step to keep your data secure!',
      });
    }
    setRedirect(true);
  };

  if (redirect) {
    if (props.kind === AccountType.App) {
      return <Redirect to={'/reset-confirmation'} />;
    }
    return <Redirect to={'/login'} />;
  }

  return (
    <>
      {bannerOpen && (
        <TopBanner
          state={FormState.SUCCESS}
          description="To boost your account’s security and protect your information, please update your password. This helps guard against threats and keeps your account safe. Thank you for your cooperation."
          onCloseBanner={() => setBannerOpen(false)}
        />
      )}
      <LoginContainer
        data-testid="reset"
        header="Update password"
        description="Create a strong password to keep your account secure. Start typing to see guidelines below."
        includeForm={false}
        kind={props.kind}
      >
        <ChangePasswordNew
          data-testid="reset"
          buttonText={'Update password'}
          onPasswordChangeSuccess={onPasswordChangeSuccess}
          updateWithToken={true}
          token={props.token}
        />
      </LoginContainer>
    </>
  );
};

export default ResetPassword;
